module.exports = __webpack_public_path__ + "img/ficha_Bancomer.c197a12c.jpg";